import { useNavigate } from "react-router-dom";
import { AppRouteURL, AppRouteURLwithChilds, DetailsRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import './Header.scss'
import { DropdownHover } from "./Components/DropdownHover/DropdownHover";
import { useAppDispatch, useAppSelector } from "@Src/app/hooks";
import { useEffect, useRef, useState } from "react";
import { getAllClassList, getSuggestions, postAllSubjectList, postAllTestSeriesList } from "./services/Header.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { setClassList, setSubjectList, setTestSeriesList } from "@Src/app/reducers/header/headerSlice";
import DownArrow from "@Assets/svg/Home_svgs/DownArrow.svg";
import SearchIcon from "@Assets/svg/Home_svgs/SearchIcon.svg";
import ActiveSearchIcon from "@Assets/svg/HeaderSvg/ActiveSearchicon.svg";
import { Link } from 'react-router-dom';
import { isLoggedIn } from "@Src/utils/service/app.utility.service";
import { clearUserData } from "@Src/app/reducers/auth/loginSlice";
import { clearCoursePreferences, setCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";
import { persistor } from "@Src/app/store";
import { useUserDisplayName } from "@Src/utils/userDisplayName";
import { toast } from "react-hot-toast";
import { getUserDeviceDetails } from "@Src/utils/service/device-details.service";
import { AutoComplete } from 'primereact/autocomplete';
import SearchCloseSvg from "@Assets/svg/HeaderSvg/Searchclose.svg"
import LogoutSvg from "@Assets/svg/HeaderSvg/Logout.svg";
import ActiveLogoutSvg from "@Assets/svg/HeaderSvg/ActiveLogout.svg";
import { useFormik } from "formik";
import { ReactComponent as IabhyasLogo } from "@Src/assets/svg/iabhyas-logo.svg";
import SvgIcon from "@Components/icons/SvgIcon";
import NavMenu from "@Components/NavMenu/NavMenu";
import { Tooltip } from 'react-tooltip';
import { getClassList, getCouresePreferences, UpdateCoursePrefernces } from "@Src/features/UserProfile/Services/UserProfile.sevice";

const Header = () => {

    const navigation = useNavigate();
    const [allClassList, setAllClassList] = useState<Array<any>>([]);
    const dispatch = useAppDispatch();
    const [allSubjectList, setAllSubjectList] = useState<Array<any>>([]);
    const [allTestSeriesList, setAllTestSeriesList] = useState<Array<any>>([]);
    const headerStore = useAppSelector(state => state.header);
    const displayName = useUserDisplayName();
    const lastName = useAppSelector(state => state.login.Lastname)
    const InstituteId = useAppSelector(state => state.login.InstituteId)

    const instituteLogoUrl = useAppSelector(state => state.login.Institutelogoimageurl)
    const profileImageUrl = useAppSelector(state => state.login.profileImageUrl)
    const isLogin = isLoggedIn();
    const coursePreferences = useAppSelector(state => state.coursePreferences);
    const targetExam = coursePreferences?.boardDetails?.[0]?.Name;
    const currentpath = window.location.pathname;
    const [suggestions, setSuggestions] = useState<Array<any>>([]);
    const [selectedSuggestion, setSelectedSuggestion] = useState<Array<any>>([]);
    const [isScrolled, setIsScrolled] = useState(false);
    const [classList, setClassList] = useState<any[]>([]);
    const [visibleClasses, setVisibileClasses] = useState<boolean>(false);

    const language = useAppSelector(state => state.login.LanguageName);
    const languageId = useAppSelector(state => state.login.LanguageId);
    const targetClass = coursePreferences?.classDetails?.[0]?.Name;

    const classSelectorRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const search = (event: any) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            if (!event.query.trim().length) {
            }
            else if (event.query.trim().length < 3) {
            } else {
                let searchText = event.query.trim();
                getSearchSuggestions(searchText)
            }
        }, 250);
    }

    const fetchClassList = async (boardId: number) => {
        try {
            const response: APIResponse = await getClassList({ boardId });
            if (response.ResponseType === APIStatus.SUCCESS && response.data) {
                setClassList(response.data);
                //    submitFilters.updateClasses?.(response.data);
                console.log("class list fetched successfully:", response.data);
            }
        } catch (error) {
            console.error('Failed to fetch class list:', error);
        }
    };

    const fetchCoursePreferences = async () => {
        try {
            const coursePreferencesResponse = await getCouresePreferences();
            if (coursePreferencesResponse?.ResponseType === APIStatus.SUCCESS && coursePreferencesResponse.data) {
                dispatch(setCoursePreferences(coursePreferencesResponse.data));
            }
        } catch (err) {
            console.error("Failed to fetch course preferences after registration", err);
        }
    }

    const handleClassUpdate = async (id: number) => {
        if (id !== coursePreferences.classDetails[0]?.Id) {

            try {
                const response = await UpdateCoursePrefernces({
                    languageListId: languageId,
                    classlistId: [id],
                    boardListId: [coursePreferences.boardDetails[0]?.Id],
                    subjectListId: coursePreferences.subjectDetails.map(({ Id }) => Id),
                    educationInterestListId: coursePreferences.educationInterestDetails.map(({ Id }) => Id),
                });
                if (response.ResponseType === APIStatus.SUCCESS && response.data) {
                    fetchCoursePreferences();
                    toast.success("Class updated successfully")
                }

            } catch (error) {
                toast.error("Failed to update the class")
            }
        }
        setVisibileClasses(false);
    }

    useEffect(() => {
        fetchClassList(coursePreferences?.boardDetails?.[0]?.Id);
    }, [coursePreferences])

    useEffect(() => {
        fetchCoursePreferences();
    }, [])


    useEffect(() => {
        const handleOutsideClick = (event: PointerEvent) => {
            if (
                visibleClasses &&
                classSelectorRef.current &&
                !classSelectorRef.current.contains(event.target as Node)
            ) {
                setVisibileClasses(false);
            }
        };

        document.addEventListener("pointerdown", handleOutsideClick);
        return () => document.removeEventListener("pointerdown", handleOutsideClick);
    }, [visibleClasses]);

    /**
     * get initial List of Class
     */
    // useEffect(() => {
    //     getClassList();
    //     getSubjectList();
    //     getTestSeriesList();
    // }, []);

    // useEffect(() => {
    //     if (allClassList && allClassList.length > 0) {
    //         dispatch(setClassList(allClassList));
    //     }
    // }, [allClassList]);

    // useEffect(() => {
    //     if (allSubjectList && allSubjectList.length > 0) {
    //         dispatch(setSubjectList(allSubjectList));
    //     }
    // }, [allSubjectList]);

    // useEffect(() => {
    //     if (allTestSeriesList && allTestSeriesList.length > 0) {
    //         dispatch(setTestSeriesList(allTestSeriesList));
    //     }
    // }, [allTestSeriesList]);

    /**
     * get initial List of Class
     */
    // function getClassList() {
    //     getAllClassList().then((response: APIResponse) => {
    //         if (response?.ResponseType == APIStatus.SUCCESS) {
    //             let data = response?.data;
    //             setAllClassList(response?.data);
    //         }
    //     })
    // }

    // function getSubjectList() {
    //     postAllSubjectList().then((response: APIResponse) => {
    //         if (response?.ResponseType == APIStatus.SUCCESS) {
    //             setAllSubjectList(response?.data.sort((a: any, b: any) => a.Name.localeCompare(b.Name)));
    //         }
    //     })
    // }

    // function getTestSeriesList() {
    //     postAllTestSeriesList().then((response: APIResponse) => {
    //         if (response?.ResponseType == APIStatus.SUCCESS) {
    //             setAllTestSeriesList(response?.data);
    //         }
    //     })
    // }
    const logout = async () => {
        dispatch(clearUserData());
        dispatch(clearCoursePreferences());
        try {
            await persistor.purge();
        } catch (error) {
            console.error("Persistor purge error:", error);
        }
        localStorage.removeItem('persist:root');
        localStorage.removeItem('redirectAfterSubscription');
        toast.success('You have loggged out successfully');
        window.location.replace(`${process.env.REACT_APP_MAIN_SITE_URL}?logout=true`);
    }


    const itemTemplate = (item: any) => {

        return (
            <div className="search-suggetion-box"  >
                <div>
                    <div className="sug-head"> {item.Name}</div>
                    <div className="sub-sug-card">
                        {item.PName1 ? <> <span>{item.PName1}</span></> : ""}
                        {item.PName2 ? <>| <span>{item.PName2}</span></> : ""}
                        {item.PName3 ? <>| <span>{item.PName3}</span></> : ""}
                    </div>

                </div>

            </div>
        );
    };

    const onEnterAutocomplete = (e: any) => {
        setSelectedSuggestion(e.value);
        if (e.originalEvent && (e.originalEvent.type == "click" || e.originalEvent.key == "Enter"))
            clickEventHandler(e.value)
    }

    function getSearchSuggestions(searchText: string) {
        let data = {
            'searchKey': searchText
        }
        getSuggestions(data).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                setSuggestions(response?.data);
            } else {
                setSuggestions([])
            }
        })
    }

    const clickEventHandler = (item: any) => {
        navigation(`${DetailsRouteURL.SEARCH}?${item.Flag}Id=${item.Id}&${item.Flag}Name=${item.Name}${item.PFlag1 ? `&${item.PFlag1}Id=${item.PId1}&${item.PFlag1}Name=${item.PName1}` : ''}${item.PFlag2 ? `&${item.PFlag2}Id=${item.PId2}&${item.PFlag2}Name=${item.PName2}` : ''}${item.PFlag3 ? `&${item.PFlag3}Id=${item.PId3}&${item.PFlag3}Name=${item.PName3}` : ''}`)
        onClickCrossSearch()
    }

    const onClickCrossSearch = () => {
        setSelectedSuggestion([]);
        setSuggestions([])
    }
    return (
        /* <!-------------------------------------header-section-------------------------------> */
        <>
            <section className={`header-container sticky-top py-2 px-0 sticky top-0 tw-z-[9999] ${isScrolled ? 'glass-effect' : ''}`}>
                <div className="ia-container tw-flex tw-item-center tw-justify-between">
                    <div className="tw-flex tw-items-center">
                        <div className="header-logo">
                            <Link to='/'>
                                {InstituteId && instituteLogoUrl ? (
                                    <img src={instituteLogoUrl} alt="Institute Logo" className="iabhyas-logo" style={{ height: '100px', marginRight: '35px' }} />
                                ) : (
                                    <IabhyasLogo className="iabhyas-logo" />
                                )}
                            </Link>
                        </div>


                    </div>
                    {!isLogin && <div className="tw-flex tw-items-center ">
                        {/* <div className="header-searchbox">
                            <AutoComplete placeholder="Want to take a test?" field="Name" className="auto-search-input" value={selectedSuggestion}
                                suggestions={suggestions} completeMethod={search} minLength={3} delay={250}
                                onChange={(e: any) => { onEnterAutocomplete(e) }} itemTemplate={itemTemplate}
                                autoHighlight={true} showEmptyMessage={true} emptyMessage={'Suggestions Not Found'}
                            />
                            {selectedSuggestion && selectedSuggestion.length > 0 ? <div onClick={() => setSelectedSuggestion([])} className="search-clear-card"> <img src={SearchCloseSvg} className="search-svg-img " /></div> : <div className="search-drop-down-container">
                                <img src={ActiveSearchIcon} className="search-svg-img" />
                            </div>}
                        </div> */}
                        {/* <div className="dropdown-container">
                            {headerStore.class && headerStore.class.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Class' list={headerStore.class} pageName={DetailsRouteURL.CLASSES_DETAILS} />
                            </div> : ''}
                            {headerStore.subject && headerStore.subject.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Subject' list={headerStore.subject} pageName={DetailsRouteURL.SUBJECT_DETAILS} />
                            </div> : ''}
                            {headerStore.testSeries && headerStore.testSeries.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Test Series' list={headerStore.testSeries} pageName={TestSereisRouteURL.TEST_SERIES} />
                            </div> : ''}

                        </div> */}
                        <NavMenu onClose={() => { }} />
                        <div className="sign-card">
                            <a href={AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.LOGIN.path} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.LOGIN.path); }}>Sign in</a>
                        </div>
                        <div className="create-accnt-btn">
                            <a href={AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.REGISTER.path} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.AUTH + AppRouteURLwithChilds.AUTH.childrens.REGISTER.path); }}> Create an Account</a>
                        </div>
                    </div>}
                    {isLogin && <div className="user-loged-in ">
                        {/* <div className="header-searchbox">
                            <AutoComplete placeholder="Want to take a test?" field="Name" className="auto-search-input" value={selectedSuggestion}
                                suggestions={suggestions} completeMethod={search} minLength={3} delay={250}
                                onChange={(e: any) => { onEnterAutocomplete(e) }} itemTemplate={itemTemplate}
                                autoHighlight={true} showEmptyMessage={true} emptyMessage={'Suggestions Not Found'}
                            />
                            {selectedSuggestion && selectedSuggestion.length > 0 ? <div onClick={() => setSelectedSuggestion([])} className="search-clear-card"> <img src={SearchCloseSvg} className="search-svg-img " /></div> : <div className="search-drop-down-container">
                                <img src={ActiveSearchIcon} className="search-svg-img" />
                            </div>}
                        </div> */}
                        {/* <div className="dropdown-container">
                            {headerStore.class && headerStore.class.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Class' list={headerStore.class} pageName={DetailsRouteURL.CLASSES_DETAILS} />
                            </div> : ''}
                            {headerStore.subject && headerStore.subject.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Subject' list={headerStore.subject} pageName={DetailsRouteURL.SUBJECT_DETAILS} />
                            </div> : ''}
                            {headerStore.testSeries && headerStore.testSeries.length > 0 ? <div className="header-dropdowns-card">
                                <DropdownHover Heading='Test Series' list={headerStore.testSeries} pageName={TestSereisRouteURL.TEST_SERIES} />
                            </div> : ''}

                        </div> */}
                        <NavMenu onClose={() => { }} />
                        <div className="user-profile-container">
                            <div className="user-profile-header-main tw-flex tw-justify-end">
                                <div data-tooltip-id="profile-tooltip" data-tooltip-content="My Profile" className="user-name tw-cursor-pointer" style={{ width: '36px', height: '36px', overflow: 'hidden' }} onClick={() => { navigation(AppRouteURL.USERPROFILE + AppRouteURL.MYPROFILE) }}>
                                    {profileImageUrl ? (
                                        <span><img src={profileImageUrl} alt="Profile" className="twt-w-full twt-h-full tw-object-cover tw-rounded-full" /></span>
                                    ) : (
                                        <span><img src={require("@Assets/img/profile-picture.png")} alt="" className="twt-w-full twt-h-full tw-object-cover" /></span>
                                    )}
                                </div>
                                <Tooltip id="profile-tooltip" place="bottom" style={{ fontSize: '12px', padding: '4px 8px' }} />
                                <ul className="login-drop-down-prof-dash">
                                    <li className="dropdown-ui-1" style={{ padding: "8px 5px" }}><a href="#" className="tw-text-nowrap tw-text-sm" style={{ textTransform: 'none' }} onClick={(e) => e.preventDefault()}>{displayName}<span className="down-arrow-svg">
                                        <SvgIcon name="downArrow" />
                                    </span></a>
                                        <ul className="dropdown-ui-container">
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.DASHBOARD_HOME)}><a href={AppRouteURL.DASHBOARD + AppRouteURL.DASHBOARD_HOME} onClick={(e) => { e.preventDefault(); navigation((AppRouteURL.DASHBOARD + AppRouteURL.DASHBOARD_HOME), { state: { reload: true } }); }}>Dashboard</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES)}><a href={TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES} onClick={(e) => { e.preventDefault(); navigation(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES); }}>Readiness Check</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.TEST_SERIES)}><a href={TestSereisRouteURL.TEST_SERIES} onClick={(e) => { e.preventDefault(); navigation(TestSereisRouteURL.TEST_SERIES); }}>Practice Test</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES)}><a href={TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES} onClick={(e) => { e.preventDefault(); navigation(TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES); }}>Previous Year Test</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.FULL_MOCK_TEST_SERIES)}><a href={TestSereisRouteURL.FULL_MOCK_TEST_SERIES} onClick={(e) => { e.preventDefault(); navigation(TestSereisRouteURL.FULL_MOCK_TEST_SERIES); }}>Mock Test</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD)}><a href={AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD); }}>Study Profile</a></li>
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}><a href={AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY); }}>My Test</a></li>
                                            {/* <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.VIDEO_BRANCHING)}><a href={AppRouteURL.VIDEO_BRANCHING} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.VIDEO_BRANCHING); }}>Concept Videos</a></li> */}
                                            <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.MIND_MAP)}><a href={AppRouteURL.DASHBOARD + AppRouteURL.MIND_MAP} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.DASHBOARD + AppRouteURL.MIND_MAP); }}>Revision Hub</a></li>

                                            {/* <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}><a href={AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY); }}>Test Activity</a></li> */}


                                            {!InstituteId && <li className="user-dropdown-li text-sm px-2 py-2"><a href={AppRouteURL.SUBSCRIPTION} onClick={(e) => { e.preventDefault(); navigation(AppRouteURL.SUBSCRIPTION); }}>My Subscription</a></li>}

                                            <li className="user-dropdown-li text-sm px-2 py-2"><a onClick={(e) => { e.preventDefault(); logout(); }} href="#">
                                                {/* <span>
                                                    <img src={LogoutSvg} className="head-logout-img" alt="logout-svg" />
                                                </span>
                                                <span>
                                                    <img src={ActiveLogoutSvg} className="head-active-logout-img" alt="logout-svg" />
                                                </span>*/}
                                                Logout</a></li>
                                        </ul >
                                    </li>
                                </ul>
                            </div>
                            {targetExam && targetClass && (
                                // <div className="user-exam-badge-row">
                                //     <span className="exam-badge">Target Exam: {targetExam}</span>
                                // </div>
                                <div className="tw-flex tw-justify-center tw-items-center">
                                    <div className="user-exam-badge-row tw-cursor-pointer" onClick={() => { navigation(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD) }}>
                                        <span className="tw-text-xs tw-font-semibold tw-text-purple-500 tw-flex tw-justify-center tw-items-center"><span className="tw-mr-1">
                                            <SvgIcon size={16} name="coursePreferences" />
                                        </span> {targetExam} | {language} | </span>
                                    </div>

                                    <div ref={classSelectorRef} className='tw-text-center ml-1'>

                                        <ul >
                                            <li className="" style={{ padding: "0px", position: "relative" }}><span className="tw-cursor-pointer tw-text-xs  tw-font-semibold tw-text-purple-500 " onClick={(e) => {
                                                setVisibileClasses((prev) => !prev);
                                            }}>Class: {targetClass} <span className="down-arrow-svg tw-mt-1  tw-cursor-pointer">
                                                    <SvgIcon size={10} name="downArrow" />
                                                </span></span>
                                                <ul className="dropdown-ui-container" style={{ minWidth: "100px", visibility: 'visible', display: visibleClasses ? 'block' : 'none', opacity: visibleClasses ? 'unset' : '0', zIndex: "0" }}>
                                                    {
                                                        classList.map((cls) => {
                                                            return (
                                                                <li className="user-dropdown-li tw-text-sm tw-px-3 tw-py-0 tw-text-start tw-cursor-pointer" style={{ padding: "10px", paddingLeft: "18px", fontSize: "14px" }} onClick={() => handleClassUpdate(cls.Id)}>
                                                                    <p>
                                                                        {cls.Name}
                                                                    </p>
                                                                </li>
                                                            )
                                                        })

                                                    }



                                                </ul >
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            )}
                            {/* {
                                targetClass && 
                            } */}
                        </div>

                    </div >}
                </div>
            </section >
        </>


    );
};

export default Header;
